(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ELEMENT"));
	else if(typeof define === 'function' && define.amd)
		define("PhotoScanPlugin", ["ELEMENT"], factory);
	else if(typeof exports === 'object')
		exports["PhotoScanPlugin"] = factory(require("ELEMENT"));
	else
		root["PhotoScanPlugin"] = factory(root["ELEMENT"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__7__) {
return 